module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[54]419.1f8fa18.woff2";